import { View } from 'react-native';

/**
 * We are not using GalleryScreen on web, this file is only placeholder
 * for import/export
 */
export const GalleryScreen = View;
